<script>

import { mapGetters } from 'vuex';

import { useAlert } from 'dashboard/composables';

import {

  DuplicateContactException,

  ExceptionWithMessage,

} from 'shared/helpers/CustomErrors';

import { dynamicTime } from 'shared/helpers/timeHelper';

import { useAdmin } from 'dashboard/composables/useAdmin';

import ContactInfoRow from './ContactInfoRow.vue';

import SocialIcons from './SocialIcons.vue';

import EditContact from './EditContact.vue';

import ContactMergeModal from 'dashboard/modules/contact/ContactMergeModal.vue';

import ContactDeleteModal from 'dashboard/modules/contact/ContactDeleteModal.vue';

import ComposeConversation from 'dashboard/components-next/NewConversation/ComposeConversation.vue';

import NextButton from 'dashboard/components-next/button/Button.vue';

import VoiceCallButton from 'dashboard/components-next/Contacts/VoiceCallButton.vue';

import InlineInput from 'dashboard/components-next/inline-input/InlineInput.vue';

import ContactProcessesModal from './ContactProcessesModal.vue';

import ProcessAuditModal from './ProcessAuditModal.vue';
import QuickContactModal from './QuickContactModal.vue';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';



export default {

  components: {

    NextButton,

    ContactInfoRow,

    EditContact,

    ComposeConversation,

    SocialIcons,

    ContactMergeModal,

    ContactDeleteModal,

    VoiceCallButton,

    InlineInput,

    ContactProcessesModal,

    ProcessAuditModal,
    QuickContactModal,

    Avatar,

  },

  props: {

    contact: {

      type: Object,

      default: () => ({}),

    },

    showAvatar: {

      type: Boolean,

      default: true,

    },

  },

  emits: ['panelClose'],

  setup() {

    const { isAdmin } = useAdmin();

    return {

      isAdmin,

    };

  },

  data() {

    return {

      showEditModal: false,

      showProcessesModal: false,

      showAuditModal: false,
      showQuickModal: false,

      auditingProcess: null,

      isEditingName: false,

      editName: '',

      isTogglingClient: false,

    };

  },

  computed: {

    ...mapGetters({

      uiFlags: 'contacts/getUIFlags',

      currentChat: 'getSelectedChat',

    }),

    contactProfileLink() {

      return `/app/accounts/${this.$route.params.accountId}/contacts/${this.contact.id}`;

    },

    additionalAttributes() {

      return this.contact.additional_attributes || this.contact.additionalAttributes || {};

    },

    customAttributes() {

      return this.contact.custom_attributes || this.contact.customAttributes || {};

    },

    isClientActive() {

      return (

        this.customAttributes.is_client === true ||

        this.customAttributes.is_client === 'true' ||

        this.additionalAttributes.is_client === true ||

        this.additionalAttributes.is_client === 'true'

      );

    },

    isContractActive() {

      return (

        this.customAttributes.signed_contract === true ||

        this.customAttributes.signed_contract === 'true' ||

        this.additionalAttributes.signed_contract === true ||

        this.additionalAttributes.signed_contract === 'true'

      );

    },

    location() {

      const {

        country = '',

        city = '',

        country_code: countryCode,

      } = this.additionalAttributes;

      const cityAndCountry = [city, country].filter(item => !!item).join(', ');



      if (!cityAndCountry) {

        return '';

      }

      return this.findCountryFlag(countryCode, cityAndCountry);

    },

    socialProfiles() {

      const {

        social_profiles: socialProfiles,

        screen_name: twitterScreenName,

        social_telegram_user_name: telegramUsername,

      } = this.additionalAttributes;



      const telegram = socialProfiles?.telegram || telegramUsername || '';

      const twitter = socialProfiles?.twitter || twitterScreenName || '';



      return {

        ...(socialProfiles || {}),

        twitter,

        telegram,

      };

    },

  },

  watch: {

    'contact.id': {

      handler(id) {

        this.$store.dispatch('contacts/fetchContactableInbox', id);

      },

      immediate: true,

    },

  },

  methods: {

    dynamicTime,

    openQuickModal() {
      this.showQuickModal = true;
    },
    closeQuickModal() {
      this.showQuickModal = false;
    },
    toggleEditModal() {

      this.showEditModal = !this.showEditModal;

    },

    openProcessesModal() {

      this.showProcessesModal = true;

    },

    openProcessAudit(proc) {

      this.auditingProcess = proc;

      this.showAuditModal = true;

    },

    closeAuditModal() {

      this.showAuditModal = false;

      this.auditingProcess = null;

    },

    closeProcessesModal() {

      this.showProcessesModal = false;

    },

    async toggleIsClient() {

      if (this.isTogglingClient) return;

      const nextVal = !this.isClientActive;

      await this.saveClientToggle('is_client', nextVal);

    },

    async toggleSignedContract() {

      if (this.isTogglingClient) return;

      const nextVal = !this.isContractActive;

      await this.saveClientToggle('signed_contract', nextVal);

    },

    async saveClientToggle(key, value) {

      try {

        this.isTogglingClient = true;

        const currentCustom = { ...(this.contact.custom_attributes || this.contact.customAttributes || {}) };

        const currentAdd = { ...(this.contact.additional_attributes || this.contact.additionalAttributes || {}) };

        currentCustom[key] = value;

        currentAdd[key] = value;



        await this.$store.dispatch('contacts/update', {

          id: this.contact.id,

          custom_attributes: currentCustom,

          customAttributes: currentCustom,

          additional_attributes: currentAdd,

          additionalAttributes: currentAdd,

        });

        await this.$store.dispatch('contacts/show', { id: this.contact.id });

        useAlert(value ? 'Marcado com sucesso!' : 'Desmarcado com sucesso!');

      } catch (error) {

        useAlert('Erro ao atualizar status do cliente.');

      } finally {

        this.isTogglingClient = false;

      }

    },

    formatDate(dateStr) {

      if (!dateStr) return '-';

      const parts = dateStr.split('-');

      if (parts.length === 3) {

        return `${parts[2]}/${parts[1]}/${parts[0]}`;

      }

      return dateStr;

    },

    getProcessLawyer(proc) {

      if (!proc) return '';

      return proc.lawyers || proc.lawyer || proc.advogado || proc.advogados || proc.responsible_lawyer || '';

    },

    getProcessUrl(proc) {

      if (proc?.url && proc.url.trim().length > 0) return proc.url;

      if (proc?.number) {

        const rawNumber = proc.number.replace(/[^0-9.-]/g, '');

        return `https://esaj.tjsp.jus.br/cpopg/search.do?cbPesquisa=NUMPROC&dadosConsulta.valorConsulta=${encodeURIComponent(rawNumber)}`;

      }

      return '';

    },

    getProcessStatusStyle(status) {

      const s = (status || '').toLowerCase().trim();

      if (s.includes('andamento')) {

        return {

          backgroundColor: 'rgba(16, 185, 129, 0.20)',

          color: '#34d399',

          border: '1px solid rgba(16, 185, 129, 0.50)',

        };

      }

      if (s.includes('ganho') || s.includes('pago') || s.includes('conclu') || s.includes('procedente')) {

        return {

          backgroundColor: 'rgba(59, 130, 246, 0.20)',

          color: '#60a5fa',

          border: '1px solid rgba(59, 130, 246, 0.50)',

        };

      }

      if (s.includes('recurso') || s.includes('viabilidade') || s.includes('pendente')) {

        return {

          backgroundColor: 'rgba(245, 158, 11, 0.20)',

          color: '#fbbf24',

          border: '1px solid rgba(245, 158, 11, 0.50)',

        };

      }

      if (s.includes('perdido') || s.includes('cancelado') || s.includes('arquivado') || s.includes('suspenso')) {

        return {

          backgroundColor: 'rgba(244, 63, 94, 0.20)',

          color: '#fb7185',

          border: '1px solid rgba(244, 63, 94, 0.50)',

        };

      }

      return {

        backgroundColor: 'rgba(148, 163, 184, 0.20)',

        color: '#cbd5e1',

        border: '1px solid rgba(148, 163, 184, 0.50)',

      };

    },

    copyCNJ(text) {

      if (!text) return;

      navigator.clipboard?.writeText(text);

      useAlert('Número do CNJ copiado!');

    },

    onProcessesUpdated() {

      this.$store.dispatch('contacts/show', { id: this.contact.id });

    },

    findCountryFlag(countryCode, cityAndCountry) {

      try {

        const countryCodeEmoji = countryCode

          .toUpperCase()

          .replace(/./g, char =>

            String.fromCodePoint(char.charCodeAt(0) + 127397)

          );

        return `${countryCodeEmoji} ${cityAndCountry}`;

      } catch (error) {

        return cityAndCountry;

      }

    },

    toggleEditName() {

      this.isEditingName = !this.isEditingName;

      this.editName = this.contact.name;

    },

    onNameUpdate() {

      if (!this.editName) {

        useAlert(this.$t('EDIT_CONTACT.FORM.NAME.ERROR'));

        return;

      }

      this.onFieldUpdate('name', this.editName);

      this.isEditingName = false;

    },

    async onFieldUpdate(field, value) {

      try {

        await this.$store.dispatch('contacts/update', {

          id: this.contact.id,

          [field]: value,

        });

        useAlert(this.$t('EDIT_CONTACT.SUCCESS_MESSAGE'));

      } catch (error) {

        if (error instanceof DuplicateContactException) {

          useAlert(error.message);

        } else if (error instanceof ExceptionWithMessage) {

          useAlert(error.message);

        } else {

          useAlert(this.$t('EDIT_CONTACT.ERROR_MESSAGE'));

        }

      }

    },

    async updateContactField(payload) {

      try {

        await this.$store.dispatch('contacts/update', {

          id: this.contact.id,

          ...payload,

        });

        useAlert(this.$t('EDIT_CONTACT.SUCCESS_MESSAGE'));

      } catch (error) {

        useAlert(this.$t('EDIT_CONTACT.ERROR_MESSAGE'));

      }

    },

  },

};

</script>



<template>

  <div class="relative w-full text-left bg-transparent pt-4 px-2">

    <div class="flex flex-col items-start w-full gap-3">

      

      <!-- FOTO DO CLIENTE: DOBRADA DE TAMANHO COM BORDAS BOLEADAS ÂNGULO 20 (rounded-[20px]) -->

      <div v-if="showAvatar" class="w-full flex items-center justify-center mb-1">

        <Avatar
          :src="contact.thumbnail"
          :name="contact.name"
          :size="80"
          hide-offline-status
          class="!rounded-[20px] [&>span]:!rounded-[20px] [&_img]:!rounded-[20px] shadow-sm cursor-pointer hover:opacity-85 hover:scale-105 active:scale-95 transition-all duration-200"
          title="Clique para abrir detalhes e edição do contato"
          @click="openQuickModal"
        />

      </div>



      <!-- NOME E IDENTIFICAÇÃO DO CONTATO (JUSTIFICADO À ESQUERDA) -->

      <div class="flex flex-col items-start w-full gap-1">

        <div class="flex items-center justify-between w-full gap-2 group">

          <InlineInput

            v-if="isEditingName"

            v-model="editName"

            class="w-full text-left"

            @blur="onNameUpdate"

            @keydown.enter="onNameUpdate"

            @keydown.escape="toggleEditName"

          />

          <h3
            v-else
            class="text-base font-bold text-left cursor-pointer text-slate-900 dark:text-slate-100 break-words leading-tight hover:text-[#1F93FF] transition-colors"
            title="Clique para abrir detalhes rápidos"
            @click="openQuickModal"
          >
            {{ contact.name }}
          </h3>

          <div class="flex items-center gap-1.5 shrink-0">

            <button
              type="button"
              class="leading-3 text-slate-400 hover:text-blue-500 dark:hover:text-blue-400 transition-colors cursor-pointer"
              title="Edição Rápida (Pop-up Glass)"
              @click="openQuickModal"
            >
              <span class="i-lucide-pencil text-sm" />
            </button>
            <span

              v-if="contact.additional_attributes?.description"

              v-tooltip="

                `${$t('CONTACT_PANEL.DESCRIPTION')}: ${

                  contact.additional_attributes?.description

                }`

              "

              class="i-lucide-info text-sm text-slate-400"

            />

            <a

              :href="contactProfileLink"

              target="_blank"

              rel="noopener nofollow noreferrer"

              class="leading-3 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"

            >

              <span class="i-lucide-external-link text-sm" />

            </a>

          </div>

        </div>



        <p v-if="additionalAttributes.description" class="break-words text-xs text-slate-500 dark:text-slate-400 mb-1 text-left">

          {{ additionalAttributes.description }}

        </p>



        <!-- LISTA DE DETALHES CLEAN, SEM MOLDURA, ESPAÇAMENTO CURTO E ALTO CONTRASTE -->

        <div class="flex flex-col items-start w-full gap-0.5 mt-1">

          <ContactInfoRow

            :href="contact.email ? `mailto:${contact.email}` : ''"

            :value="contact.email"

            icon="mail"

            emoji="✉️"

            title="E-mail"

            show-copy

            editable

            @update="value => onFieldUpdate('email', value)"

          />

          <ContactInfoRow

            :href="contact.phone_number ? `tel:${contact.phone_number}` : ''"

            :value="contact.phone_number"

            icon="call"

            emoji="📞"

            title="Telefone"

            show-copy

            editable

            @update="value => onFieldUpdate('phone_number', value)"

          />

          <ContactInfoRow

            v-if="contact.identifier"

            :value="contact.identifier"

            icon="contact-identify"

            emoji="🪪"

            title="Identificador"

          />

          <ContactInfoRow

            v-if="additionalAttributes.company_name"

            :value="additionalAttributes.company_name"

            icon="building-bank"

            emoji="🏢"

            title="Empresa"

            editable

            @update="

              value =>

                updateContactField({

                  additional_attributes: {

                    ...additionalAttributes,

                    company_name: value,

                  },

                })

            "

          />

          <ContactInfoRow

            v-if="additionalAttributes.cpf"

            :value="additionalAttributes.cpf"

            icon="card-heading"

            emoji="🪪"

            title="CPF"

            show-copy

            editable

            @update="value => updateContactField({ additional_attributes: { ...additionalAttributes, cpf: value } })"

          />

          <ContactInfoRow

            v-if="additionalAttributes.physical_folder"

            :value="additionalAttributes.physical_folder"

            icon="folder"

            emoji="📁"

            title="Pasta Física"

            editable

            @update="value => updateContactField({ additional_attributes: { ...additionalAttributes, physical_folder: value } })"

          />

          <ContactInfoRow

            v-if="additionalAttributes.google_drive_link"

            :value="additionalAttributes.google_drive_link"

            icon="link"

            emoji="🔗"

            title="Google Drive"

            :href="additionalAttributes.google_drive_link"

            show-copy

            editable

            @update="value => updateContactField({ additional_attributes: { ...additionalAttributes, google_drive_link: value } })"

          />

          <ContactInfoRow

            v-if="additionalAttributes.inss_password"

            :value="additionalAttributes.inss_password"

            icon="lock"

            emoji="🔑"

            title="Senha INSS"

            show-copy

            editable

            @update="value => updateContactField({ additional_attributes: { ...additionalAttributes, inss_password: value } })"

          />

          <ContactInfoRow

            v-if="location || additionalAttributes.location"

            :value="location || additionalAttributes.location"

            icon="map"

            emoji="📍"

            title="Endereço"

          />

          <SocialIcons :social-profiles="socialProfiles" />

        </div>



        <!-- CAIXINHA BOLEADA DOS CHECKBOXES (COM ESTILOS DARK/LIGHT EXPLICITOS) -->

        <div class="custom-capsule-box w-full flex items-center justify-around py-2.5 px-3 rounded-2xl shadow-2xs mt-2 transition-colors">

          <!-- Item 1: É Cliente? -->

          <div

            class="flex items-center gap-2 cursor-pointer select-none group"

            @click="toggleIsClient"

          >

            <div

              class="custom-checkbox-box w-4 h-4 rounded flex items-center justify-center transition-all shrink-0 shadow-2xs"

              :class="{ 'is-active': isClientActive }"

            >

              <span v-if="isClientActive" class="text-[10px] font-black leading-none text-white">✓</span>

            </div>

            <span class="text-xs font-bold text-slate-800 dark:text-slate-200 flex items-center gap-1">

              <span>⚖️</span>

              <span>É Cliente?</span>

            </span>

          </div>



          <!-- Divisor Sutil -->

          <div class="w-px h-4 bg-slate-300 dark:bg-slate-700 shrink-0" />



          <!-- Item 2: Contrato Assinado -->

          <div

            class="flex items-center gap-2 cursor-pointer select-none group"

            @click="toggleSignedContract"

          >

            <div

              class="custom-checkbox-box w-4 h-4 rounded flex items-center justify-center transition-all shrink-0 shadow-2xs"

              :class="{ 'is-active': isContractActive }"

            >

              <span v-if="isContractActive" class="text-[10px] font-black leading-none text-white">✓</span>

            </div>

            <span class="text-xs font-bold text-slate-800 dark:text-slate-200 flex items-center gap-1">

              <span>✍️</span>

              <span>Contrato Assinado</span>

            </span>

          </div>

        </div>



        <!-- SEÇÃO DE PROCESSOS REFORMULADA (COM ESTILOS DARK/LIGHT EXPLICITOS) -->

        <div class="w-full mt-3">

          <!-- Cabeçalho da Seção -->

          <div class="flex items-center justify-between mb-2 px-0.5">

            <h4 class="text-xs font-bold text-slate-800 dark:text-slate-200 flex items-center gap-1.5 uppercase tracking-wide">

              <span class="text-sm">⚖️</span> Processos

              <span

                v-if="additionalAttributes.processes && additionalAttributes.processes.length"

                class="text-[10px] px-1.5 py-0.2 rounded-full bg-[#1F93FF]/15 text-[#1F93FF] dark:text-[#1F93FF] font-bold border border-[#1F93FF]/30"

              >

                {{ additionalAttributes.processes.length }}

              </span>

            </h4>

            <button

              type="button"

              class="text-[11px] font-bold text-[#1F93FF] dark:text-[#1F93FF] hover:underline flex items-center gap-1 cursor-pointer transition-colors"

              @click="openProcessesModal"

            >

              <span class="i-lucide-plus size-3"></span>

              <span>+ Adicionar</span>

            </button>

          </div>



          <!-- Lista de Processos Cadastrados -->

          <div v-if="additionalAttributes.processes && additionalAttributes.processes.length" class="flex flex-col gap-2">

            <div

              v-for="(proc, index) in additionalAttributes.processes"

              :key="index"

              class="custom-process-card p-2.5 rounded-xl transition-all cursor-pointer group shadow-2xs"

              @click="openProcessesModal"

            >

              <!-- Linha 1: Tipo da Ação -->

              <div class="flex items-center justify-between gap-1.5 mb-1">

                <span class="text-xs font-bold text-slate-900 dark:text-slate-100 truncate leading-snug">

                  {{ proc.type || 'Processo Judicial' }}

                </span>

              </div>



              <!-- Linha 2: Número do CNJ Clicável (Abre no Tribunal / ESAJ TJSP) -->

              <div v-if="proc.number" class="text-[11px] mb-1 flex items-center justify-between">

                <a

                  :href="getProcessUrl(proc)"

                  target="_blank"

                  rel="noopener noreferrer"

                  class="font-mono font-semibold text-[#1F93FF] hover:underline inline-flex items-center gap-1 transition-colors"

                  title="Abrir no Tribunal / ESAJ TJSP"

                  @click.stop

                >

                  <span>{{ proc.number }}</span>

                  <span class="text-[11px] opacity-80 hover:opacity-100">🔗</span>

                </a>

                <button

                  type="button"

                  class="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 transition-opacity p-0.5 ml-1"

                  title="Copiar CNJ"

                  @click.stop="copyCNJ(proc.number)"

                >

                  📋

                </button>

              </div>



              <!-- Linha 2.5: Advogado Responsável (Logo abaixo do número do processo) -->

              <div

                v-if="getProcessLawyer(proc)"

                class="text-[11px] mb-1.5 flex items-center gap-1.5 text-slate-700 dark:text-slate-200 min-w-0"

              >

                <span class="text-[11px] shrink-0 opacity-80 select-none" title="Advogado Responsável">⚖️</span>

                <span class="truncate font-medium text-[11px] leading-snug text-slate-700 dark:text-slate-200" :title="getProcessLawyer(proc)">

                  {{ getProcessLawyer(proc) }}

                </span>

              </div>



              <!-- Linha 3: Distribuição + Botão Auditar + Situação com Tarja Colorida Nítida -->

              <div class="flex items-center justify-between gap-1.5 text-[10px] mt-1 pt-1 border-t border-slate-100 dark:border-slate-800">

                <span v-if="proc.date" class="text-slate-500 dark:text-slate-400 font-medium">

                  Distr: {{ formatDate(proc.date) }}

                </span>

                <span v-else class="text-slate-500 dark:text-slate-400 font-medium">

                  Distr: -

                </span>



                <!-- BOTÃO ROSA AUDITAR COM MOTOR DE IA (ESTILIZADO & NÍTIDO) -->

                <button

                  type="button"

                  class="btn-auditar-processo"

                  title="Auditar andamentos e verificar providências com IA"

                  @click.stop="openProcessAudit(proc)"

                >

                  <span class="auditar-icon">🔍</span>

                  <span class="auditar-text">Auditar</span>

                </button>

                

                <span

                  v-if="proc.status"

                  class="px-2.5 py-0.5 rounded-full text-[10px] font-bold tracking-tight shrink-0 shadow-2xs select-none"

                  :style="getProcessStatusStyle(proc.status)"

                >

                  {{ proc.status }}

                </span>

              </div>

            </div>

          </div>



          <!-- Estado Vazio (Sem processos) -->

          <div v-else class="custom-process-card py-3 text-center rounded-xl p-3">

            <p class="text-xs text-slate-500 dark:text-slate-400 mb-2">

              Nenhum processo cadastrado

            </p>

            <button

              type="button"

              class="inline-flex items-center justify-center gap-1.5 w-full py-1.5 px-3 rounded-lg border border-dashed border-[#1F93FF]/40 text-xs font-semibold text-[#1F93FF] hover:bg-[#1F93FF]/5 transition-colors cursor-pointer"

              @click="openProcessesModal"

            >

              <span class="i-lucide-plus size-3.5"></span>

              <span>+ Adicionar Processo</span>

            </button>

          </div>

        </div>

      </div>



      <!-- BOTÕES DE AÇÃO RÁPIDA -->

      <div class="flex items-center w-full mt-1 gap-2">

        <ComposeConversation :contact-id="String(contact.id)">

          <template #trigger>

            <NextButton

              v-tooltip.top-end="$t('CONTACT_PANEL.NEW_MESSAGE')"

              icon="i-ph-chat-circle-dots"

              slate

              faded

              sm

            />

          </template>

        </ComposeConversation>

        <VoiceCallButton

          :phone="contact.phone_number"

          :contact-id="contact.id"

          :conversation-id="currentChat?.id"

          icon="i-lucide-phone"

          sm

          faded

          slate

          :tooltip-label="$t('CONTACT_PANEL.CALL')"

        />

        <NextButton

          v-tooltip.top-end="$t('EDIT_CONTACT.BUTTON_LABEL')"

          icon="i-ph-pencil-simple"

          slate

          faded

          sm

          @click="toggleEditModal"

        />

        <ContactMergeModal :primary-contact="contact">

          <template #trigger>

            <NextButton

              v-tooltip.top-end="$t('CONTACT_PANEL.MERGE_CONTACT')"

              icon="i-ph-arrows-merge"

              slate

              faded

              sm

              :disabled="uiFlags.isMerging"

            />

          </template>

        </ContactMergeModal>

        <ContactDeleteModal

          v-if="isAdmin"

          :contact="contact"

          @deleted="$emit('panelClose')"

        >

          <template #trigger>

            <NextButton

              v-tooltip.top-end="$t('DELETE_CONTACT.BUTTON_LABEL')"

              icon="i-ph-trash"

              slate

              faded

              sm

              ruby

              :disabled="uiFlags.isDeleting"

            />

          </template>

        </ContactDeleteModal>

      </div>

      <!-- MODAL RÁPIDO DE DETALHES & ATRIBUTOS DO CONTATO (GLASSMORPHISM) -->
      <QuickContactModal
        :show="showQuickModal"
        :contact="contact"
        @close="closeQuickModal"
        @updated="onProcessesUpdated"
      />

      <EditContact

        :show="showEditModal"

        :contact="contact"

        @cancel="toggleEditModal"

      />



          <!-- MODAL DE AUDITORIA PROCESSUAL COM IA -->

    <ProcessAuditModal

      :show="showAuditModal"

      :process="auditingProcess"

      :contact="contact"

      @close="closeAuditModal"

      @task-created="onProcessesUpdated"

    />



    <!-- MODAL DE PROCESSOS COMPLETO -->

      <ContactProcessesModal

        :show="showProcessesModal"

        :contact="contact"

        @close="closeProcessesModal"

        @updated="onProcessesUpdated"

      />

    </div>

  </div>

</template>



<style scoped>

.custom-capsule-box {

  background-color: #f1f5f9;

  border: 1px solid #e2e8f0;

}

:global(.dark) .custom-capsule-box,

:global(body.dark) .custom-capsule-box,

.dark .custom-capsule-box {

  background-color: #181b20 !important;

  border-color: #262b35 !important;

}



.custom-process-card {

  background-color: #ffffff;

  border: 1px solid #e2e8f0;

}

:global(.dark) .custom-process-card,

:global(body.dark) .custom-process-card,

.dark .custom-process-card {

  background-color: #181b20 !important;

  border-color: #262b35 !important;

}



.custom-checkbox-box {

  background-color: #ffffff;

  border: 1px solid #cbd5e1;

}

:global(.dark) .custom-checkbox-box,

:global(body.dark) .custom-checkbox-box,

.dark .custom-checkbox-box {

  background-color: #101216 !important;

  border-color: #3b4252 !important;

}

.custom-checkbox-box.is-active {

  background-color: #1f93ff !important;

  border-color: #1f93ff !important;

  color: #ffffff !important;

}



.btn-auditar-processo {

  display: inline-flex !important;

  align-items: center !important;

  gap: 4px !important;

  background: linear-gradient(135deg, #EC4899 0%, #E11D48 100%) !important;

  color: #ffffff !important;

  font-weight: 700 !important;

  font-size: 10px !important;

  padding: 3px 8px !important;

  border-radius: 6px !important;

  border: 1px solid rgba(255, 255, 255, 0.3) !important;

  box-shadow: 0 1px 4px rgba(225, 29, 72, 0.3) !important;

  cursor: pointer !important;

  transition: all 0.15s ease-in-out !important;

  user-select: none !important;

  white-space: nowrap !important;

}



.btn-auditar-processo:hover {

  background: linear-gradient(135deg, #DB2777 0%, #BE123C 100%) !important;

  transform: translateY(-1px) scale(1.04) !important;

  box-shadow: 0 3px 6px rgba(225, 29, 72, 0.4) !important;

}



.btn-auditar-processo:active {

  transform: scale(0.96) !important;

}



.auditar-icon {

  font-size: 10px !important;

  line-height: 1 !important;

}



.auditar-text {

  font-size: 10.5px !important;

  font-weight: 800 !important;

  letter-spacing: 0.2px !important;

  color: #ffffff !important;

}



</style>

